import { takeLatest, call, put } from "redux-saga/effects";

import * as types from "../actions/actionTypes";
import { ProvinceAction } from "../actions";
import * as provinceApi from "../api/province";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherProvince() {
  yield takeLatest(types.PROVINCE_REQUEST, workerProvince);
  yield takeLatest(types.CITY_REQUEST, workerCity);
}

function fetchProvince() {
  return provinceApi.getProvince();
}

function* workerProvince() {
  try {
    const response = yield call(fetchProvince);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const data = response.data;
    yield put(
      ProvinceAction.getSuccess({
        provinces: data.data
      })
    );
  } catch (error) {
    yield put(ProvinceAction.getFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

function fetchCity(data) {
  return provinceApi.getCity(data.id);
}

function* workerCity(action) {
  try {
    const response = yield call(fetchCity, action.data);
    const data = response.data;
    yield put(
      ProvinceAction.getCitySuccess({
        province_cities: data.data
      })
    );
  } catch (error) {
    yield put(ProvinceAction.getCityFailure());
    if (error.response) {
      checkErrorMessagesExist(error) &&
        error.response.data.message.forEach(message => {
          toastr.error(" ", message.toString());
        });
    }
  }
}
